import { render, staticRenderFns } from "./TurnaroundTrainNumberFields.vue?vue&type=template&id=4458c368"
import script from "./TurnaroundTrainNumberFields.vue?vue&type=script&lang=js"
export * from "./TurnaroundTrainNumberFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports